import styles from '../Calculator.module.css';

interface Props {
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max?: number;
  label: string;
}

export function Stepper({ value, onChange, min = 0, max = 10, label }: Props) {
  return (
    <div className={styles.stepper} role="group" aria-label={label}>
      <div className={styles.stepperInnerContainer}>
        <button
          type="button"
          className={styles.stepperBtn}
          onClick={() => onChange(Math.max(min, value - 1))}
          disabled={value <= min}
          aria-label="Verringern"
        >
          −
        </button>
        <span className={styles.stepperValue} aria-live="polite" aria-atomic="true">
          {value}
        </span>
        <button
          type="button"
          className={styles.stepperBtn}
          onClick={() => onChange(Math.min(max, value + 1))}
          disabled={value >= max}
          aria-label="Erhöhen"
        >
          +
        </button>
      </div>
    </div>
  );
}
